import { gql } from '../__generated__';

export const ENTITY_PAGE_UNFOLLOW_MUTATION = gql(`
  mutation xcpEntityPageUnfollow($followedId: ID!) {
    entityPageUnfollow(input: { followedId: $followedId }) {
      error {
        message
      }
    }
  }
`);
